/* Rude — theme scripts. No dependencies. */
(function () {
  'use strict';

  var money = function (cents, format) {
    var value = (cents / 100).toFixed(2);
    if (format && format.indexOf('amount_no_decimals') > -1) {
      value = Math.round(cents / 100).toString();
    }
    return '$' + value;
  };

  /* -------------------------------------------------- header interactions */

  function initHeader() {
    document.addEventListener('click', function (event) {
      var navToggle = event.target.closest('[data-nav-toggle]');
      if (navToggle) {
        var nav = document.querySelector('[data-nav]');
        if (nav) {
          var open = nav.classList.toggle('is-open');
          navToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        }
      }

      var searchToggle = event.target.closest('[data-search-toggle]');
      if (searchToggle) {
        var search = document.querySelector('[data-search]');
        if (search) {
          var isOpen = search.classList.toggle('is-open');
          searchToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
          if (isOpen) {
            var input = search.querySelector('input[type="search"]');
            if (input) input.focus();
          }
        }
      }
    });
  }

  /* ------------------------------------------------------ quantity steppers */

  function initQuantity() {
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-qty-change]');
      if (!button) return;
      event.preventDefault();
      var wrap = button.closest('.qty');
      if (!wrap) return;
      var input = wrap.querySelector('input');
      var min = parseInt(input.getAttribute('min') || '1', 10);
      var next = (parseInt(input.value, 10) || min) + parseInt(button.dataset.qtyChange, 10);
      input.value = next < min ? min : next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* -------------------------------------------------------- product gallery */

  function initGallery() {
    document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
      var main = gallery.querySelector('[data-gallery-main]');
      gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          if (!main) return;
          main.src = thumb.dataset.full;
          main.srcset = '';
          main.alt = thumb.dataset.alt || '';
          gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (other) {
            other.setAttribute('aria-current', other === thumb ? 'true' : 'false');
          });
        });
      });
    });
  }

  function showMediaForVariant(variant) {
    if (!variant || !variant.featured_image) return;
    var main = document.querySelector('[data-gallery-main]');
    if (!main) return;
    main.src = variant.featured_image.src;
    main.srcset = '';
  }

  /* ------------------------------------------------------- variant picking */

  function initVariants() {
    document.querySelectorAll('[data-product-form]').forEach(function (form) {
      var dataEl = form.querySelector('[data-variants]');
      if (!dataEl) return;

      var variants;
      try {
        variants = JSON.parse(dataEl.textContent);
      } catch (error) {
        return;
      }

      var idInput = form.querySelector('[data-variant-id]');
      var submit = form.querySelector('[data-add-button]');
      var priceEl = document.querySelector('[data-product-price]');
      var skuEl = document.querySelector('[data-product-sku]');
      var format = dataEl.dataset.moneyFormat || '';

      function selectedOptions() {
        var values = [];
        form.querySelectorAll('[data-option-index]').forEach(function (input) {
          if (input.type === 'radio' && !input.checked) return;
          values[parseInt(input.dataset.optionIndex, 10)] = input.value;
        });
        return values;
      }

      /* blocks tagged with an option value only show while that value is
         selected — lets Regular and Spicy each carry their own ingredients */
      function applyConditionalBlocks(chosen) {
        document.querySelectorAll('[data-when-option]').forEach(function (element) {
          element.hidden = chosen.indexOf(element.dataset.whenOption) === -1;
        });
      }

      function update() {
        var chosen = selectedOptions();
        applyConditionalBlocks(chosen);
        var match = variants.filter(function (variant) {
          return chosen.every(function (value, index) {
            return variant.options[index] === value;
          });
        })[0];

        if (!match) {
          if (submit) {
            submit.disabled = true;
            submit.textContent = 'Unavailable';
          }
          return;
        }

        if (idInput) idInput.value = match.id;
        if (submit) {
          submit.disabled = !match.available;
          submit.textContent = match.available ? submit.dataset.addLabel : 'Sold out';
        }
        if (priceEl) {
          var html = '<span class="price__now">' + money(match.price, format) + '</span>';
          if (match.compare_at_price && match.compare_at_price > match.price) {
            html += '<span class="price__compare">' + money(match.compare_at_price, format) + '</span>';
            priceEl.classList.add('price--on-sale');
          } else {
            priceEl.classList.remove('price--on-sale');
          }
          priceEl.innerHTML = html;
        }
        if (skuEl) skuEl.textContent = match.sku || '';

        /* keep the per-ounce figure in step with the selected variant's price */
        var unitEl = document.querySelector('[data-unit-price]');
        if (unitEl) {
          var netOz = parseFloat(unitEl.dataset.netOz);
          if (netOz > 0) {
            unitEl.textContent = money(Math.round(match.price / netOz), format) + ' / oz';
          }
        }

        showMediaForVariant(match);

        if (history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          history.replaceState({}, '', url.toString());
        }
      }

      form.addEventListener('change', update);

      /* set the initial state without rewriting the URL or price */
      applyConditionalBlocks(selectedOptions());
    });
  }

  /* --------------------------------------------------------------- quick add */

  function refreshCartCount() {
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (node) {
          node.textContent = cart.item_count;
          node.hidden = cart.item_count === 0;
        });
      })
      .catch(function () {});
  }

  function initQuickAdd() {
    document.addEventListener('submit', function (event) {
      var form = event.target.closest('[data-quick-add]');
      if (!form) return;
      event.preventDefault();

      var button = form.querySelector('button[type="submit"]');
      var label = button ? button.textContent : '';
      if (button) {
        button.disabled = true;
        button.textContent = 'Adding...';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: form.querySelector('[name="id"]').value, quantity: 1 }],
        }),
      })
        .then(function (response) {
          return response.json();
        })
        .then(function () {
          refreshCartCount();
          if (button) {
            button.textContent = 'Added';
            setTimeout(function () {
              button.disabled = false;
              button.textContent = label;
            }, 1400);
          }
        })
        .catch(function () {
          form.submit();
        });
    });
  }

  /* ------------------------------------------------------ recommendations */

  function initRecommendations() {
    document.querySelectorAll('[data-recommendations]').forEach(function (holder) {
      if (holder.dataset.loaded === 'true') return;
      holder.dataset.loaded = 'true';

      fetch(holder.dataset.url)
        .then(function (response) {
          return response.text();
        })
        .then(function (text) {
          var parsed = new DOMParser().parseFromString(text, 'text/html');
          var section = parsed.querySelector('.section');
          if (section) {
            holder.replaceWith(section);
          }
        })
        .catch(function () {});
    });
  }

  /* ------------------------------------------------------------------- boot */

  function boot() {
    initHeader();
    initQuantity();
    initGallery();
    initVariants();
    initQuickAdd();
    initRecommendations();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
